module.exports = "/assets/data/473944e66cd452489f276d8e4ebe7857-G72.data.json";